var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { getImageURL } from '../../../../utils/GeneralUtil';
var constants = {
    title: "VIP Experiences",
    subtitle: "Participate in one-of-a-kind experiences, only for top members. Contact our account management team for more information.",
    iconUrl: getImageURL("WelcomeCard/active_VIP Experiences.svg"),
};
var VIPExperiencesMW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var VIPExperiencesFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var VIPExperiencesHalfWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var VIPExperiences = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth;
    var mockProp = props.mockProp; // TODO: Remove after demo
    var data = { isMobile: isMobile, isLocked: isLocked };
    if (isMobile)
        return React.createElement(VIPExperiencesMW, __assign({}, data));
    // if (fullWidth) return <BusinessToolsHalfWidthDTW {...data} />;
    // return <BusinessToolsHalfWidthDTW {...data} />;
    // For Demo
    if (fullWidth)
        return React.createElement(VIPExperiencesFullWidthDTW, __assign({}, data, { mockProp: mockProp }));
    return React.createElement(VIPExperiencesHalfWidthDTW, __assign({}, data, { mockProp: mockProp }));
};
